import { get } from 'lodash-es';

import { ColStats } from '@style/pages/col.style';

import { Card } from '@atom/card/card';
import { Row } from '@atom/grid/row/row';
import { getFormattedNumber } from '@util/data/number';

import { TitleStat, Value } from './consumer-stats.styles';
import { useConsumerStats } from './use-consumer-stats.hook';

export const ConsumerStats = () => {
  const { data } = useConsumerStats();

  return (
    <Card title='Consumer usage'>
      <Row gutter={16}>
        <ColStats id='consumer-1' span={8}>
          <TitleStat>Connection</TitleStat>
          <Value>{getFormattedNumber(get(data, ['data', 'connection'], 0))}</Value>
        </ColStats>
        <ColStats id='consumer-2' span={8}>
          <TitleStat>Universal</TitleStat>
          <Value>{getFormattedNumber(get(data, ['data', 'universal'], 0))}</Value>
        </ColStats>
        <ColStats id='consumer-3' span={8}>
          <TitleStat>Total requests</TitleStat>
          <Value>{getFormattedNumber(get(data, ['data', 'total'], 0))}</Value>
        </ColStats>
      </Row>
    </Card>
  );
};
